import { render, staticRenderFns } from "./UnBlockAssistantModal.vue?vue&type=template&id=28e56f54&"
import script from "./UnBlockAssistantModal.vue?vue&type=script&lang=js&"
export * from "./UnBlockAssistantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports